import React from "react";
import "../App.css";

const NoMatch = (props) => <h1>Oops! Page not found!</h1>;

export default NoMatch;
